module.exports = __webpack_public_path__ + "static/media/1014663.bb56ab6c.jpg";